import { getVisionsQuery } from '@griply/services';
import {
  CollectionReference,
  Firestore,
  limit,
  orderBy,
  Query,
  QueryConstraint,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';
import { Vision } from 'shared/types/vision';

import { visionConverter } from './converters/vision';
import {
  CollectionOptions,
  getAuthentication,
  getCollection,
  getDatabase,
  query,
  where,
} from './helpers';

export type Options = {
  lifeAreaIds?: ID[];
  limit?: number;
};

export const getVisions = async (options: Options = {}) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  return getVisionsQuery<
    CollectionReference<Vision>,
    Query<Vision>,
    QueryConstraint,
    Firestore
  >({
    db: getDatabase(),
    collection: () =>
      getCollection(CollectionOptions.Visions).withConverter(visionConverter),
    query: query as (
      ref: CollectionReference<Vision>,
      ...constraints: QueryConstraint[]
    ) => Query<Vision>,
    where: where as (
      field: string,
      op: string,
      value: unknown,
    ) => QueryConstraint,
    orderBy: orderBy as (
      field: string,
      direction?: 'asc' | 'desc',
    ) => QueryConstraint,
    limit: limit as (count: number) => QueryConstraint,
    userId: user.uid,
    lifeAreaIds: options.lifeAreaIds,
    maxResults: options.limit,
  });
};
